import { render, staticRenderFns } from "./SubTab.vue?vue&type=template&id=69cd3649&"
import script from "./SubTab.vue?vue&type=script&lang=js&"
export * from "./SubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports